export default __webpack_public_path__ + "static/media/LiveNyteNoImage.bdfc2083.jpg";